import { Form, Formik } from 'formik';
import { FC } from 'react';

import { ResetPasswordFormValidation } from '@/authentication/templates/AuthFormLegacy/Forms/Forms.types';
import { CheckoutDescription } from '@/checkout/components/CheckoutDescription/CheckoutDescription';
import { MICROCOPY } from '@/data/microcopy/microcopyDictionary';
import { Button } from '@/general/components/Button/Button';
import { InputEmailFormik } from '@/general/components/forms/Input/InputEmailFormik';
import { getMicrocopy } from '@/stores/microcopyStore';

import styles from './PersonalizedQuoteForm.module.scss';
import { PersonalizedQuoteFormProps, ResetPasswordFormValues } from './PersonalizedQuoteForm.type';

const initialValues: ResetPasswordFormValues = {
  email: '',
};

export const ResetPasswordForm: FC<PersonalizedQuoteFormProps<ResetPasswordFormValues>> = ({
  onSubmit,
  values,
  onBack,
}) => (
  <>
    <div className={styles.checkoutDescription}>
      <CheckoutDescription
        title={getMicrocopy(MICROCOPY.AUTHENTICATION_RESET_PASSWORD_FORM_TITLE)}
        description={getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_FORGOT_PASSWORD_DESCRIPTION)}
        onBack={onBack}
      />
    </div>
    <div className={styles.resetPasswordForm}>
      <Formik
        initialValues={{ ...initialValues, ...values }}
        validateOnBlur={false}
        onSubmit={onSubmit}
        validationSchema={ResetPasswordFormValidation}
      >
        {(props) => (
          <Form className={styles.form} noValidate>
            <InputEmailFormik
              name="email"
              label="Email address"
              autoFocus
              id="resetpassword-email"
              defaultValue={values.email}
            />
            <footer className={styles.footer}>
              <Button type="submit" isLoading={props.isSubmitting} fullWidth data-testid="submit">
                {getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_FORGOT_PASSWORD_CTA)}
              </Button>
            </footer>
          </Form>
        )}
      </Formik>
    </div>
  </>
);
